/**
 * @private
 * getUniqueSymbol - Take a row of data, and return the UniqueSymbol
 *
 * @param  {Object} row    a row of data
 * @return {String} symbol a symbol or array of symbols that have been transformed into EXCHANGE:SYMBOL
 */
export function getUniqueSymbol(row) {
	if (!row) return null;

	let exchange = '',
		symbol = '',
		delimiter = ':';

	if (row.hasOwnProperty('Symbol')) {
		symbol = row.Symbol.toUpperCase();
	}
	else {
		return null;
	}

	if (row.hasOwnProperty('ExchangePrefixCode')) {
		exchange = row.ExchangePrefixCode.toUpperCase();
	}
	else {
		return null;
	}
	// else {
	// 	delimiter = '';
	// }
	// Leaving delimiter as ':' even if ExchangePrefixCode is missing, as
	// discussed in CR. Would be an indication to other modules that
	// it's in EXCHANGE:SYMBOL format if something else is reuqired by Yahoo

	return `${exchange}${delimiter}${symbol}`;
}
